'use client';

import { TableColumnDurationText, tableColumnDurationTextTag } from '@ni/nimble-components/dist/esm/table-column/duration-text';
import { wrap } from '../../utilities/react-wrapper';

export { tableColumnDurationTextTag };
export { type TableColumnDurationText };
export const NimbleTableColumnDurationText = wrap(TableColumnDurationText);
